/**
 * iOS home-screen badge helpers (Capacitor).
 * Combined count = notification unread + message conversation unread.
 *
 * `@capawesome/capacitor-badge` calls `requestPermissions()` inside every
 * `set`/`clear`, which shows the iOS notification dialog. We only touch the
 * badge API after OS permission is already `granted` (via Enable Push /
 * notification settings) so launch and pre-opt-in sync never prompt.
 */

import { Capacitor } from '@capacitor/core';
import { Badge } from '@capawesome/capacitor-badge';

async function hasBadgePermission() {
  try {
    const status = await Badge.checkPermissions();
    return status?.display === 'granted';
  } catch {
    return false;
  }
}

/**
 * @param {number} count
 */
export async function setAppIconBadge(count) {
  if (!Capacitor.isNativePlatform()) return;
  const n = Math.max(0, Math.floor(Number(count) || 0));
  try {
    if (!(await hasBadgePermission())) return;
    if (n === 0) {
      await Badge.clear();
      return;
    }
    await Badge.set({ count: n });
  } catch {
    /* best-effort — never block UI */
  }
}

export async function clearAppIconBadge() {
  await setAppIconBadge(0);
}
